import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_CHECK_IF_SHOULD_REQUEST_MOVE_IN_DATE_CHANGE } from 'api/actionTypes';

import { hasRolePartner, hasRoleLandlord } from 'common/userRoles';

export default function checkIfShouldRequestMoveInDateChange({ state, apiClient }) {
  const currentUserRoles = state.get(['currentUser', 'roles']);

  if (hasRolePartner(currentUserRoles) || hasRoleLandlord(currentUserRoles)) {
    return;
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_CHECK_IF_SHOULD_REQUEST_MOVE_IN_DATE_CHANGE,
    state: state,
    onSuccess(shouldRequestMoveInDateChangeCheck) {
      typeCheck('shouldRequestMoveInDateChangeCheck::Boolean', shouldRequestMoveInDateChangeCheck);
      state.set(['updateMoveInDate', 'modalOpen'], shouldRequestMoveInDateChangeCheck);
      state.set(['updateMoveInDate', 'forceMoveInDateUpdate'], shouldRequestMoveInDateChangeCheck);
    },
  });
}
